import "frontend/features/clients/components/ClientQuickview.css.ts.vanilla.css!=!../../../../node_modules/@vanilla-extract/webpack-plugin/virtualFileLoader/dist/vanilla-extract-webpack-plugin-virtualFileLoader.cjs.js?{\"fileName\":\"frontend/features/clients/components/ClientQuickview.css.ts.vanilla.css\",\"source\":\"#H4sIAAAAAAAAA61Vy27bMBC8-yt4jAvQsB2_ynxKURRrckUtSpEEubacFvn3QrThyvIjSJuTAM1ydjg7K00Ouo1kp-L3SAhDOTp4VaJyeHgZCQGOrJfE2GQlNHrG1L22EJXYQ3qS8sdstm78HmbLcYc05GVLhmslpi-jt9HkSD-7Td89paGEmil4JXRwu8Y_4JkXnip4lpl-4ZUIW0To4EIaYqtxj-e58IQ9psqFVomajMHSmPHA8i-AzlHMlDuorYlR5ggalfChTRB7lIv_dnDRV7j8qGO3GC_uvPp8xm8GGKQLYMjb70dPI2jiVyWmk1WvdF3AGsnWrIQGp5_mm434MuD_Oe7zbz5D8aJEIoLpNMptYA7NzWsJsQ3JYDrXzOJB5ODIDKqfLzQqB5mlrsmZIndA4oPHWwL6qf5aDjaQLPmCPIp4PT7j7cnOQQU_XoJTxjmBz1VIjRK7GDFpyEWoQ2ZMJebkbTfH6QKbnlq4nIpNZIr3iYxkbKIDRnmcSVZiWSWxrtLVKmSGxI--Jed-29Lv_Z3WRxdvfzjMpWjyjjzKf1zSu13wY4E9n6s-K-hnRvvYtFMGDOqQ4EheDOE6hZ2te0T1dTbfHwVdHzrl_85v47Q0CQzt8rBmjr2a-2tp7se-g97-AIITl7zqBgAA\"}!../../../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"
export var actions = 'xcwpig4';
export var address = 'xcwpige';
export var alert = 'xcwpigi';
export var archived = 'xcwpigg';
export var body = 'xcwpig6';
export var content = 'xcwpig5';
export var empty = 'xcwpigh';
export var field = 'xcwpiga';
export var id = 'xcwpig2';
export var identity = 'xcwpig1';
export var label = 'xcwpigb';
export var name = 'xcwpig3';
export var person = 'xcwpigd';
export var placeholder = 'xcwpig7';
export var projects = 'xcwpigf';
export var section = 'xcwpig8';
export var sectionTitle = 'xcwpig9';
export var title = 'xcwpig0';
export var value = 'xcwpigc';